<template>
  <div class="vc-main">
    <h1>Vuetify Components</h1>

    <h2>Select:</h2>

    <v-row>
      <v-col cols="12" md="4">
        <v-select
          :menu-props="{ bottom: true, offsetY: true }"
          :items="items"
          label="Label field"
          solo
          outlined
        ></v-select>
      </v-col>
    </v-row>

    <h2>Text Field:</h2>

    <v-row>
      <v-col cols="12" md="4">
        <v-text-field label="Label field" placeholder=" " outlined></v-text-field>
      </v-col>
    </v-row>

    <h2>Text Area:</h2>

    <v-row>
      <v-col cols="12" md="4">
        <v-textarea label="Label field" placeholder=" " outlined></v-textarea>
      </v-col>
    </v-row>

    <h2>Radio Button, Checkbox:</h2>

    <v-row>
      <v-col cols="6" md="4">
        <v-radio-group v-model="radioGroup">
          <v-radio label="Value 1" value="1"></v-radio>
          <v-radio label="Value 2" value="2"></v-radio>
        </v-radio-group>
      </v-col>

      <v-col cols="6" md="4">
        <v-checkbox v-model="checkbox" label="Checkbox"></v-checkbox>
      </v-col>
    </v-row>

    <h2>Switch:</h2>

    <v-row>
      <v-col cols="12" md="4">
        <v-switch v-model="switchModel" label="Switch"></v-switch>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'VuetifyComponents',
  data: () => ({
    radioGroup: 1,
    switchModel: true,
    checkbox: false,
    items: ['Foo', 'Bar', 'Fizz', 'Buzz']
  })
}
</script>
